import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import AssetValuePickerModal from './AssetValuePickerModal'
import FilterLink from '../../../components/filter/FilterLink'

const AssetValuePicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiToolsFill'}
        label={label || 'Ativo'}
        value={compactString(value, { t: t, tField: 'assetIds' })}
        onClick={() => setOpen(true)}
      />
      <AssetValuePickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default AssetValuePicker
